<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <div class="card-img-actions d-inline-block mb-3">
      <img class="img-fluid rounded-circle" v-bind:src="url" alt="" width="170" height="170">
      <div class="card-img-actions-overlay card-img rounded-circle">
        <a @click="openModal" href="#" class="btn btn-outline-dark border-2 btn-icon rounded-pill">
          <i class="icon-plus3"></i>
        </a>
      </div>
    </div>

    <modal-default ref="modaleditor" :onsave="saving" v-bind:title="$t('upload')">
      <upload-file-selector2 ref="uploader" @change="urlChange"></upload-file-selector2>
    </modal-default>
  </div>

</template>

<script>

  import UploadSelector2 from "../upload/upload-file-selector2.vue";
  import ModalDefault from "../modals/modal-default.vue";

  export default {
    name: "user-icon",
    components: {
      UploadSelector2,
      ModalDefault
    },
    props: {
      url: {
        type: String,
        default: null
      },
    },
    data() {
      return {

      };
    },
    methods: {
      openModal() {
        this.$refs.modaleditor.open();
      },

      urlChange(val, text) {

        this.$refs.uploader.reset();
        this.$refs.modaleditor.close();
      },

      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {

      }
    },
    computed: {
     
    },
    watch: {
      
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>

  

  .card .border-blue {
    border-color: #03a9f4 !important;
  }
  
  .card:hover {
    box-shadow: 0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/user-icon.vue